var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-card"},[_c('div',{staticClass:"title"},[_vm._v(" 您的个人信息将呈现在律临PC/移动端个人主页上 ")]),_c('div',{staticClass:"pic"}),_c('div',{staticClass:"btn",on:{"click":_vm.clickPreview}},[_vm._v("预览我的主页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }